export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // же 'auto' for instant jump кайсынысы жакшырак болорун билбей турам, өзүңүз карап көрсүп койсоңуз болот
  });
};
